import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import backgroundImg from './img/background.webp';

function HeroParallax() {
  const { scrollYProgress } = useScroll();

  // We shift from 0% to 30% as the user scrolls through the entire page
  // (or you can do a more advanced approach that only reacts while the hero is in view)
  const bgY = useTransform(scrollYProgress, [0, 1], ['0%', '120%']);

  return (
    <motion.div
      style={{
        position: 'absolute',
        inset: 0,
        zIndex: -1,
        background: `
          linear-gradient(rgba(0,0,0,0.85), rgba(0,0,0,0.7)),
          url(${backgroundImg}) no-repeat center
        `,
        backgroundSize: '200vh',
        backgroundPositionY: bgY,
      }}
    />
  );
}

export default HeroParallax;
